import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/(legacy)/creators/programs/$programId")({
  component: CreatorsProgramLayout,
});

function CreatorsProgramLayout() {
  return <Outlet />;
}
